import { inject, customAttribute } from "aurelia-framework";
import { AuthService } from "../services/auth/auth-service";

/**
 * Disables or hides the attached element if the current user does not have
 * one of the rights given in the attribute's value.
 *
 * Example:
 * <button k-requires-right="admin-read, admin-write"></button>
 *
 * Input elements are disabled, all other elements (div, label etc.) are hidden.
 */
@customAttribute("k-requires-right")
@inject(Element, AuthService)
export class KRequiresRightCustomAttribute {
  constructor(
    private element: Element,
    private authService: AuthService,
  ) {}

  bind() {
    let value: string = (<any>this).value;
    let rights: string[] = value ? value.split(/[, ]+/) : [];
    let enabled = this.authService.hasRightOneOf(rights);
    if (Object.getPrototypeOf(this.element).hasOwnProperty("disabled")) {
      this.element["disabled"] = !enabled;
    } else {
      this.element["style"].visibility = enabled ? "visible" : "hidden";
    }
  }
}
